// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Bulk Import System Styles */

.bulk-import-container {
  padding: 20px;
  background: #f8f9fa;
  min-height: 100vh;
}

.bulk-import-wizard {
  background: white;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

/* Progress Steps */
.import-steps {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 20px;
  color: white;
}

.steps-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.step {
  display: flex;
  align-items: center;
  flex: 1 1;
  position: relative;
}

.step-circle {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
  font-weight: bold;
  transition: all 0.3s ease;
}

.step.active .step-circle {
  background: #28a745;
  color: white;
}

.step.completed .step-circle {
  background: #007bff;
  color: white;
}

.step-content {
  flex: 1 1;
}

.step-title {
  font-weight: 600;
  margin-bottom: 2px;
}

.step-description {
  font-size: 0.85em;
  opacity: 0.8;
}

.step-connector {
  flex: 1 1;
  height: 2px;
  background: rgba(255, 255, 255, 0.3);
  margin: 0 15px;
}

.step-connector.completed {
  background: #007bff;
}

/* Content Area */
.steps-content {
  padding: 30px;
  min-height: 400px;
}

.step-panel {
  animation: fadeIn 0.3s ease-in;
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
}

/* File Upload Step */
.upload-area {
  border: 3px dashed #dee2e6;
  border-radius: 10px;
  padding: 60px 20px;
  text-align: center;
  background: #f8f9fa;
  transition: all 0.3s ease;
  cursor: pointer;
}

.upload-area:hover,
.upload-area.dragover {
  border-color: #007bff;
  background: #e7f1ff;
}

.upload-icon {
  font-size: 4rem;
  color: #6c757d;
  margin-bottom: 20px;
}

.upload-area.dragover .upload-icon {
  color: #007bff;
}

.upload-text {
  font-size: 1.2rem;
  color: #495057;
  margin-bottom: 10px;
}

.upload-subtext {
  color: #6c757d;
  font-size: 0.9rem;
}

.file-info {
  background: #e9ecef;
  border-radius: 8px;
  padding: 20px;
  margin-top: 20px;
}

.file-info-header {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}

.file-icon {
  font-size: 2rem;
  color: #28a745;
  margin-right: 10px;
}

.file-details h5 {
  margin: 0;
  color: #495057;
}

.file-details p {
  margin: 5px 0 0 0;
  color: #6c757d;
  font-size: 0.9rem;
}

/* Field Mapping */
.mapping-container {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 20px;
  margin: 20px 0;
}

.mapping-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 1px solid #dee2e6;
}

.mapping-row {
  display: flex;
  align-items: center;
  padding: 15px;
  background: white;
  border-radius: 6px;
  margin-bottom: 10px;
  border: 1px solid #dee2e6;
  transition: all 0.2s ease;
}

.mapping-row:hover {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.excel-column {
  flex: 1 1;
  font-weight: 500;
  color: #495057;
}

.mapping-arrow {
  margin: 0 20px;
  color: #007bff;
  font-size: 1.2rem;
}

.db-field-select {
  flex: 1 1;
}

.required-indicator {
  color: #dc3545;
  margin-left: 5px;
}

.suggested-badge {
  background: #e7f1ff;
  color: #0056b3;
  font-size: 0.75rem;
  padding: 2px 6px;
  border-radius: 3px;
  margin-left: 8px;
}

/* Template Management */
.template-section {
  background: #fff3cd;
  border: 1px solid #ffeaa7;
  border-radius: 6px;
  padding: 15px;
  margin: 20px 0;
}

.template-actions {
  display: flex;
  gap: 10px;
  align-items: center;
}

/* Data Preview */
.preview-container {
  margin: 20px 0;
}

.preview-row {
  display: flex;
  align-items: center;
  padding: 10px;
  border-bottom: 1px solid #dee2e6;
}

.preview-row.valid {
  background: #d4edda;
  border-left: 4px solid #28a745;
}

.preview-row.warning {
  background: #fff3cd;
  border-left: 4px solid #ffc107;
}

.preview-row.error {
  background: #f8d7da;
  border-left: 4px solid #dc3545;
}

.row-number {
  width: 60px;
  font-weight: 500;
  color: #6c757d;
}

.row-status {
  width: 80px;
  text-align: center;
}

.row-data {
  flex: 1 1;
  display: flex;
  gap: 15px;
}

.data-cell {
  flex: 1 1;
  font-size: 0.9rem;
  color: #495057;
}

.error-list {
  margin-top: 5px;
  padding-left: 20px;
}

.error-item {
  margin-bottom: 8px;
  padding: 8px;
  background: rgba(220, 53, 69, 0.1);
  border-radius: 4px;
  border-left: 3px solid #dc3545;
}

.error-header {
  font-size: 0.9rem;
  margin-bottom: 4px;
}

.error-item .small {
  line-height: 1.3;
  margin-bottom: 2px;
}

.error-item .text-info {
  background: rgba(23, 162, 184, 0.1);
  padding: 4px 8px;
  border-radius: 3px;
  margin-top: 4px;
}

/* Processing Step */
.processing-container {
  text-align: center;
  padding: 40px 20px;
}

.progress-circle {
  width: 120px;
  height: 120px;
  border-radius: 50%;
  background: conic-gradient(#007bff 0deg, #e9ecef 0deg);
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 30px;
  position: relative;
}

.progress-inner {
  width: 100px;
  height: 100px;
  background: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  font-weight: bold;
  color: #007bff;
}

.progress-stats {
  display: flex;
  justify-content: center;
  gap: 30px;
  margin: 30px 0;
}

.progress-stat {
  text-align: center;
}

.stat-number {
  font-size: 2rem;
  font-weight: bold;
  margin-bottom: 5px;
}

.stat-number.success {
  color: #28a745;
}

.stat-number.failed {
  color: #dc3545;
}

.stat-number.total {
  color: #007bff;
}

.stat-label {
  color: #6c757d;
  font-size: 0.9rem;
}

/* Results Step */
.results-summary {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border-radius: 10px;
  padding: 30px;
  margin-bottom: 30px;
}

.summary-header {
  text-align: center;
  margin-bottom: 30px;
}

.summary-stats {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
}

.summary-stat {
  text-align: center;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  padding: 20px;
}

.summary-number {
  font-size: 2.5rem;
  font-weight: bold;
  margin-bottom: 5px;
}

.summary-label {
  font-size: 1rem;
  opacity: 0.9;
}

.error-summary {
  background: white;
  border-radius: 8px;
  padding: 20px;
  margin: 20px 0;
}

.error-item-summary {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
  border-bottom: 1px solid #dee2e6;
}

.error-message {
  color: #495057;
}

.error-count {
  background: #dc3545;
  color: white;
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 0.8rem;
}

/* Action Buttons */
.steps-actions {
  padding: 20px 30px;
  background: #f8f9fa;
  border-top: 1px solid #dee2e6;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.btn-primary-custom {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
  padding: 10px 25px;
  border-radius: 6px;
  font-weight: 500;
  transition: all 0.3s ease;
}

.btn-primary-custom:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.btn-outline-custom {
  border: 2px solid #667eea;
  color: #667eea;
  background: transparent;
  padding: 8px 20px;
  border-radius: 6px;
  font-weight: 500;
  transition: all 0.3s ease;
}

.btn-outline-custom:hover {
  background: #667eea;
  color: white;
}

/* Responsive Design */
@media (max-width: 768px) {
  .steps-container {
    flex-direction: column;
    gap: 15px;
  }
  
  .step-connector {
    display: none;
  }
  
  .mapping-row {
    flex-direction: column;
    align-items: stretch;
    gap: 10px;
  }
  
  .mapping-arrow {
    margin: 10px 0;
    text-align: center;
  }
  
  .progress-stats {
    flex-direction: column;
    gap: 15px;
  }
  
  .summary-stats {
    grid-template-columns: 1fr;
  }
}

/* Loading States */
.loading-spinner {
  border: 3px solid #f3f3f3;
  border-top: 3px solid #007bff;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  animation: spin 1s linear infinite;
  margin: 0 auto;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.loading-text {
  text-align: center;
  color: #6c757d;
  margin-top: 15px;
}

/* Status Badges */
.status-badge {
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: 500;
  text-transform: uppercase;
}

.status-badge.uploaded {
  background: #cce5ff;
  color: #0056b3;
}

.status-badge.mapping {
  background: #fff3cd;
  color: #856404;
}

.status-badge.processing {
  background: #d1ecf1;
  color: #0c5460;
}

.status-badge.completed {
  background: #d4edda;
  color: #155724;
}

.status-badge.failed {
  background: #f8d7da;
  color: #721c24;
}

.status-badge.cancelled {
  background: #e2e3e5;
  color: #383d41;
}

/* Table Selection Step Enhancements */
.hover-border-secondary:hover {
  border-color: #6c757d !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transform: translateY(-1px);
}

.transition-all {
  transition: all 0.2s ease-in-out;
}

/* Search box enhancements */
.position-relative .fa-times:hover {
  color: #dc3545 !important;
}

.position-relative .fa-search {
  opacity: 0.5;
}

/* Table card animations */
.card.border-primary {
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}

/* Improved scrollbar for table list */
.table-list-container::-webkit-scrollbar {
  width: 6px;
}

.table-list-container::-webkit-scrollbar-track {
  background: #f8f9fa;
  border-radius: 3px;
}

.table-list-container::-webkit-scrollbar-thumb {
  background: #dee2e6;
  border-radius: 3px;
}

.table-list-container::-webkit-scrollbar-thumb:hover {
  background: #adb5bd;
}

/* Enhanced table cards */
.card.cursor-pointer:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.bg-primary.bg-opacity-10 {
  background-color: rgba(13, 110, 253, 0.1) !important;
}

/* Table selection search and filter styles */
.table-search-container {
  position: sticky;
  top: 0;
  background: white;
  z-index: 10;
  padding-bottom: 1rem;
  border-bottom: 1px solid #dee2e6;
  margin-bottom: 1rem;
}

.table-count-badge {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
}

/* Large table warning */
.badge.bg-warning {
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0% { opacity: 1; }
  50% { opacity: 0.7; }
  100% { opacity: 1; }
}`, "",{"version":3,"sources":["webpack://./src/Sidebar/BulkImport/BulkImport.css"],"names":[],"mappings":"AAAA,8BAA8B;;AAE9B;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,6DAA6D;EAC7D,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,SAAO;EACP,WAAW;EACX,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA,qBAAqB;AACrB;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;;EAEE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB;;AAEA,kBAAkB;AAClB;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kCAAkC;EAClC,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,sDAAsD;EACtD,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA,iBAAiB;AACjB;EACE,6DAA6D;EAC7D,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,oCAAoC;EACpC,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;EAC7B,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,SAAS;EACX;;EAEA;IACE,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA,mBAAmB;AACnB;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,sCAAsC;AACtC;EACE,gCAAgC;EAChC,wCAAwC;EACxC,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;AAClC;;AAEA,4BAA4B;AAC5B;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA,0BAA0B;AAC1B;EACE,kDAAkD;AACpD;;AAEA,sCAAsC;AACtC;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,yBAAyB;AACzB;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,oDAAoD;AACtD;;AAEA,6CAA6C;AAC7C;EACE,gBAAgB;EAChB,MAAM;EACN,iBAAiB;EACjB,WAAW;EACX,oBAAoB;EACpB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;AACd;;AAEA,wBAAwB;AACxB;EACE,4BAA4B;AAC9B;;AAEA;EACE,KAAK,UAAU,EAAE;EACjB,MAAM,YAAY,EAAE;EACpB,OAAO,UAAU,EAAE;AACrB","sourcesContent":["/* Bulk Import System Styles */\r\n\r\n.bulk-import-container {\r\n  padding: 20px;\r\n  background: #f8f9fa;\r\n  min-height: 100vh;\r\n}\r\n\r\n.bulk-import-wizard {\r\n  background: white;\r\n  border-radius: 10px;\r\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\r\n  overflow: hidden;\r\n}\r\n\r\n/* Progress Steps */\r\n.import-steps {\r\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\r\n  padding: 20px;\r\n  color: white;\r\n}\r\n\r\n.steps-container {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.step {\r\n  display: flex;\r\n  align-items: center;\r\n  flex: 1;\r\n  position: relative;\r\n}\r\n\r\n.step-circle {\r\n  width: 40px;\r\n  height: 40px;\r\n  border-radius: 50%;\r\n  background: rgba(255, 255, 255, 0.3);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  margin-right: 10px;\r\n  font-weight: bold;\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n.step.active .step-circle {\r\n  background: #28a745;\r\n  color: white;\r\n}\r\n\r\n.step.completed .step-circle {\r\n  background: #007bff;\r\n  color: white;\r\n}\r\n\r\n.step-content {\r\n  flex: 1;\r\n}\r\n\r\n.step-title {\r\n  font-weight: 600;\r\n  margin-bottom: 2px;\r\n}\r\n\r\n.step-description {\r\n  font-size: 0.85em;\r\n  opacity: 0.8;\r\n}\r\n\r\n.step-connector {\r\n  flex: 1;\r\n  height: 2px;\r\n  background: rgba(255, 255, 255, 0.3);\r\n  margin: 0 15px;\r\n}\r\n\r\n.step-connector.completed {\r\n  background: #007bff;\r\n}\r\n\r\n/* Content Area */\r\n.steps-content {\r\n  padding: 30px;\r\n  min-height: 400px;\r\n}\r\n\r\n.step-panel {\r\n  animation: fadeIn 0.3s ease-in;\r\n}\r\n\r\n@keyframes fadeIn {\r\n  from { opacity: 0; transform: translateY(10px); }\r\n  to { opacity: 1; transform: translateY(0); }\r\n}\r\n\r\n/* File Upload Step */\r\n.upload-area {\r\n  border: 3px dashed #dee2e6;\r\n  border-radius: 10px;\r\n  padding: 60px 20px;\r\n  text-align: center;\r\n  background: #f8f9fa;\r\n  transition: all 0.3s ease;\r\n  cursor: pointer;\r\n}\r\n\r\n.upload-area:hover,\r\n.upload-area.dragover {\r\n  border-color: #007bff;\r\n  background: #e7f1ff;\r\n}\r\n\r\n.upload-icon {\r\n  font-size: 4rem;\r\n  color: #6c757d;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.upload-area.dragover .upload-icon {\r\n  color: #007bff;\r\n}\r\n\r\n.upload-text {\r\n  font-size: 1.2rem;\r\n  color: #495057;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.upload-subtext {\r\n  color: #6c757d;\r\n  font-size: 0.9rem;\r\n}\r\n\r\n.file-info {\r\n  background: #e9ecef;\r\n  border-radius: 8px;\r\n  padding: 20px;\r\n  margin-top: 20px;\r\n}\r\n\r\n.file-info-header {\r\n  display: flex;\r\n  align-items: center;\r\n  margin-bottom: 15px;\r\n}\r\n\r\n.file-icon {\r\n  font-size: 2rem;\r\n  color: #28a745;\r\n  margin-right: 10px;\r\n}\r\n\r\n.file-details h5 {\r\n  margin: 0;\r\n  color: #495057;\r\n}\r\n\r\n.file-details p {\r\n  margin: 5px 0 0 0;\r\n  color: #6c757d;\r\n  font-size: 0.9rem;\r\n}\r\n\r\n/* Field Mapping */\r\n.mapping-container {\r\n  background: #f8f9fa;\r\n  border-radius: 8px;\r\n  padding: 20px;\r\n  margin: 20px 0;\r\n}\r\n\r\n.mapping-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-bottom: 20px;\r\n  padding-bottom: 15px;\r\n  border-bottom: 1px solid #dee2e6;\r\n}\r\n\r\n.mapping-row {\r\n  display: flex;\r\n  align-items: center;\r\n  padding: 15px;\r\n  background: white;\r\n  border-radius: 6px;\r\n  margin-bottom: 10px;\r\n  border: 1px solid #dee2e6;\r\n  transition: all 0.2s ease;\r\n}\r\n\r\n.mapping-row:hover {\r\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.excel-column {\r\n  flex: 1;\r\n  font-weight: 500;\r\n  color: #495057;\r\n}\r\n\r\n.mapping-arrow {\r\n  margin: 0 20px;\r\n  color: #007bff;\r\n  font-size: 1.2rem;\r\n}\r\n\r\n.db-field-select {\r\n  flex: 1;\r\n}\r\n\r\n.required-indicator {\r\n  color: #dc3545;\r\n  margin-left: 5px;\r\n}\r\n\r\n.suggested-badge {\r\n  background: #e7f1ff;\r\n  color: #0056b3;\r\n  font-size: 0.75rem;\r\n  padding: 2px 6px;\r\n  border-radius: 3px;\r\n  margin-left: 8px;\r\n}\r\n\r\n/* Template Management */\r\n.template-section {\r\n  background: #fff3cd;\r\n  border: 1px solid #ffeaa7;\r\n  border-radius: 6px;\r\n  padding: 15px;\r\n  margin: 20px 0;\r\n}\r\n\r\n.template-actions {\r\n  display: flex;\r\n  gap: 10px;\r\n  align-items: center;\r\n}\r\n\r\n/* Data Preview */\r\n.preview-container {\r\n  margin: 20px 0;\r\n}\r\n\r\n.preview-row {\r\n  display: flex;\r\n  align-items: center;\r\n  padding: 10px;\r\n  border-bottom: 1px solid #dee2e6;\r\n}\r\n\r\n.preview-row.valid {\r\n  background: #d4edda;\r\n  border-left: 4px solid #28a745;\r\n}\r\n\r\n.preview-row.warning {\r\n  background: #fff3cd;\r\n  border-left: 4px solid #ffc107;\r\n}\r\n\r\n.preview-row.error {\r\n  background: #f8d7da;\r\n  border-left: 4px solid #dc3545;\r\n}\r\n\r\n.row-number {\r\n  width: 60px;\r\n  font-weight: 500;\r\n  color: #6c757d;\r\n}\r\n\r\n.row-status {\r\n  width: 80px;\r\n  text-align: center;\r\n}\r\n\r\n.row-data {\r\n  flex: 1;\r\n  display: flex;\r\n  gap: 15px;\r\n}\r\n\r\n.data-cell {\r\n  flex: 1;\r\n  font-size: 0.9rem;\r\n  color: #495057;\r\n}\r\n\r\n.error-list {\r\n  margin-top: 5px;\r\n  padding-left: 20px;\r\n}\r\n\r\n.error-item {\r\n  margin-bottom: 8px;\r\n  padding: 8px;\r\n  background: rgba(220, 53, 69, 0.1);\r\n  border-radius: 4px;\r\n  border-left: 3px solid #dc3545;\r\n}\r\n\r\n.error-header {\r\n  font-size: 0.9rem;\r\n  margin-bottom: 4px;\r\n}\r\n\r\n.error-item .small {\r\n  line-height: 1.3;\r\n  margin-bottom: 2px;\r\n}\r\n\r\n.error-item .text-info {\r\n  background: rgba(23, 162, 184, 0.1);\r\n  padding: 4px 8px;\r\n  border-radius: 3px;\r\n  margin-top: 4px;\r\n}\r\n\r\n/* Processing Step */\r\n.processing-container {\r\n  text-align: center;\r\n  padding: 40px 20px;\r\n}\r\n\r\n.progress-circle {\r\n  width: 120px;\r\n  height: 120px;\r\n  border-radius: 50%;\r\n  background: conic-gradient(#007bff 0deg, #e9ecef 0deg);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  margin: 0 auto 30px;\r\n  position: relative;\r\n}\r\n\r\n.progress-inner {\r\n  width: 100px;\r\n  height: 100px;\r\n  background: white;\r\n  border-radius: 50%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: 1.5rem;\r\n  font-weight: bold;\r\n  color: #007bff;\r\n}\r\n\r\n.progress-stats {\r\n  display: flex;\r\n  justify-content: center;\r\n  gap: 30px;\r\n  margin: 30px 0;\r\n}\r\n\r\n.progress-stat {\r\n  text-align: center;\r\n}\r\n\r\n.stat-number {\r\n  font-size: 2rem;\r\n  font-weight: bold;\r\n  margin-bottom: 5px;\r\n}\r\n\r\n.stat-number.success {\r\n  color: #28a745;\r\n}\r\n\r\n.stat-number.failed {\r\n  color: #dc3545;\r\n}\r\n\r\n.stat-number.total {\r\n  color: #007bff;\r\n}\r\n\r\n.stat-label {\r\n  color: #6c757d;\r\n  font-size: 0.9rem;\r\n}\r\n\r\n/* Results Step */\r\n.results-summary {\r\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\r\n  color: white;\r\n  border-radius: 10px;\r\n  padding: 30px;\r\n  margin-bottom: 30px;\r\n}\r\n\r\n.summary-header {\r\n  text-align: center;\r\n  margin-bottom: 30px;\r\n}\r\n\r\n.summary-stats {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\r\n  gap: 20px;\r\n}\r\n\r\n.summary-stat {\r\n  text-align: center;\r\n  background: rgba(255, 255, 255, 0.1);\r\n  border-radius: 8px;\r\n  padding: 20px;\r\n}\r\n\r\n.summary-number {\r\n  font-size: 2.5rem;\r\n  font-weight: bold;\r\n  margin-bottom: 5px;\r\n}\r\n\r\n.summary-label {\r\n  font-size: 1rem;\r\n  opacity: 0.9;\r\n}\r\n\r\n.error-summary {\r\n  background: white;\r\n  border-radius: 8px;\r\n  padding: 20px;\r\n  margin: 20px 0;\r\n}\r\n\r\n.error-item-summary {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 10px 0;\r\n  border-bottom: 1px solid #dee2e6;\r\n}\r\n\r\n.error-message {\r\n  color: #495057;\r\n}\r\n\r\n.error-count {\r\n  background: #dc3545;\r\n  color: white;\r\n  padding: 2px 8px;\r\n  border-radius: 12px;\r\n  font-size: 0.8rem;\r\n}\r\n\r\n/* Action Buttons */\r\n.steps-actions {\r\n  padding: 20px 30px;\r\n  background: #f8f9fa;\r\n  border-top: 1px solid #dee2e6;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n}\r\n\r\n.btn-primary-custom {\r\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\r\n  border: none;\r\n  padding: 10px 25px;\r\n  border-radius: 6px;\r\n  font-weight: 500;\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n.btn-primary-custom:hover {\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n.btn-outline-custom {\r\n  border: 2px solid #667eea;\r\n  color: #667eea;\r\n  background: transparent;\r\n  padding: 8px 20px;\r\n  border-radius: 6px;\r\n  font-weight: 500;\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n.btn-outline-custom:hover {\r\n  background: #667eea;\r\n  color: white;\r\n}\r\n\r\n/* Responsive Design */\r\n@media (max-width: 768px) {\r\n  .steps-container {\r\n    flex-direction: column;\r\n    gap: 15px;\r\n  }\r\n  \r\n  .step-connector {\r\n    display: none;\r\n  }\r\n  \r\n  .mapping-row {\r\n    flex-direction: column;\r\n    align-items: stretch;\r\n    gap: 10px;\r\n  }\r\n  \r\n  .mapping-arrow {\r\n    margin: 10px 0;\r\n    text-align: center;\r\n  }\r\n  \r\n  .progress-stats {\r\n    flex-direction: column;\r\n    gap: 15px;\r\n  }\r\n  \r\n  .summary-stats {\r\n    grid-template-columns: 1fr;\r\n  }\r\n}\r\n\r\n/* Loading States */\r\n.loading-spinner {\r\n  border: 3px solid #f3f3f3;\r\n  border-top: 3px solid #007bff;\r\n  border-radius: 50%;\r\n  width: 30px;\r\n  height: 30px;\r\n  animation: spin 1s linear infinite;\r\n  margin: 0 auto;\r\n}\r\n\r\n@keyframes spin {\r\n  0% { transform: rotate(0deg); }\r\n  100% { transform: rotate(360deg); }\r\n}\r\n\r\n.loading-text {\r\n  text-align: center;\r\n  color: #6c757d;\r\n  margin-top: 15px;\r\n}\r\n\r\n/* Status Badges */\r\n.status-badge {\r\n  padding: 4px 8px;\r\n  border-radius: 12px;\r\n  font-size: 0.75rem;\r\n  font-weight: 500;\r\n  text-transform: uppercase;\r\n}\r\n\r\n.status-badge.uploaded {\r\n  background: #cce5ff;\r\n  color: #0056b3;\r\n}\r\n\r\n.status-badge.mapping {\r\n  background: #fff3cd;\r\n  color: #856404;\r\n}\r\n\r\n.status-badge.processing {\r\n  background: #d1ecf1;\r\n  color: #0c5460;\r\n}\r\n\r\n.status-badge.completed {\r\n  background: #d4edda;\r\n  color: #155724;\r\n}\r\n\r\n.status-badge.failed {\r\n  background: #f8d7da;\r\n  color: #721c24;\r\n}\r\n\r\n.status-badge.cancelled {\r\n  background: #e2e3e5;\r\n  color: #383d41;\r\n}\r\n\r\n/* Table Selection Step Enhancements */\r\n.hover-border-secondary:hover {\r\n  border-color: #6c757d !important;\r\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\r\n  transform: translateY(-1px);\r\n}\r\n\r\n.transition-all {\r\n  transition: all 0.2s ease-in-out;\r\n}\r\n\r\n/* Search box enhancements */\r\n.position-relative .fa-times:hover {\r\n  color: #dc3545 !important;\r\n}\r\n\r\n.position-relative .fa-search {\r\n  opacity: 0.5;\r\n}\r\n\r\n/* Table card animations */\r\n.card.border-primary {\r\n  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);\r\n}\r\n\r\n/* Improved scrollbar for table list */\r\n.table-list-container::-webkit-scrollbar {\r\n  width: 6px;\r\n}\r\n\r\n.table-list-container::-webkit-scrollbar-track {\r\n  background: #f8f9fa;\r\n  border-radius: 3px;\r\n}\r\n\r\n.table-list-container::-webkit-scrollbar-thumb {\r\n  background: #dee2e6;\r\n  border-radius: 3px;\r\n}\r\n\r\n.table-list-container::-webkit-scrollbar-thumb:hover {\r\n  background: #adb5bd;\r\n}\r\n\r\n/* Enhanced table cards */\r\n.card.cursor-pointer:hover {\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);\r\n}\r\n\r\n.bg-primary.bg-opacity-10 {\r\n  background-color: rgba(13, 110, 253, 0.1) !important;\r\n}\r\n\r\n/* Table selection search and filter styles */\r\n.table-search-container {\r\n  position: sticky;\r\n  top: 0;\r\n  background: white;\r\n  z-index: 10;\r\n  padding-bottom: 1rem;\r\n  border-bottom: 1px solid #dee2e6;\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n.table-count-badge {\r\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\r\n  color: white;\r\n  border: none;\r\n}\r\n\r\n/* Large table warning */\r\n.badge.bg-warning {\r\n  animation: pulse 2s infinite;\r\n}\r\n\r\n@keyframes pulse {\r\n  0% { opacity: 1; }\r\n  50% { opacity: 0.7; }\r\n  100% { opacity: 1; }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
